module.exports = __webpack_public_path__ + "pr.52b418174c3336e086a5.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/pr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/pr.svg
// module chunks = styles